<template>
  <div class="accordion"
       ref="accordion">
    <div class="toggle"
         @click.prevent="toggle">
      <span class="icon left"></span>
      <span class="title">
        <slot name="title"></slot>
      </span>
      <span class="icon right"></span>
    </div>
    <div class="panel"
         ref="panel">
      <section class="form__section">
        <slot></slot>
      </section>
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery';

export default {
  props: ['fixopen'],
  data() {
    return {
      opened: false,
    };
  },
  mounted() {
    if (this.fixopen) {
      jQuery(this.$refs.accordion).addClass('opened');
      jQuery(this.$refs.panel).slideDown(0);
      this.opened = true;
    }
  },
  methods: {
    toggle() {
      if (this.opened) {
        this.close();
      } else {
        this.open();
      }
    },
    open(complete) {
      jQuery(this.$refs.accordion).addClass('opened');
      jQuery(this.$refs.panel).slideDown(100, () => {
        this.$emit('toggle');
        if (complete) complete();
      });
      this.opened = true;
    },
    close() {
      if (this.fixopen) {
        return;
      }

      jQuery(this.$refs.accordion).removeClass('opened');
      jQuery(this.$refs.panel).slideUp(100, () => {
        this.$emit('toggle');
      });
      this.opened = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/user-profile/FormSection.vue